import React from "react";

import { Form, Checkbox, Row, Col } from "antd";

interface props {
  activeQuestion: any;
}

const MultiSelectOptions: React.FC<props> = (props) => {
  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-checkbox"
        name={props?.activeQuestion?.data?.question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Checkbox.Group>
          <Row>
            {props?.activeQuestion?.options?.map((option: any, index: any) => {
              return (
                <Col span={24} key={index}>
                  <Checkbox
                    value={typeof option === "string" ? option : option.label}
                    key={index}
                  >
                    {typeof option === "string" ? option : option.label}
                  </Checkbox>
                </Col>
              );
            })}
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </div>
  );
};

export default MultiSelectOptions;
